import { TextSortBy } from "nystem-components";

const SelectSortBy = (props) => <TextSortBy {...props} />;
export default SelectSortBy;
